<template>
  <div class="centered">
    <d-table
      v-if="tableReady"
      :data_object="data_object"
      :getFreshData="true"
      :key="compKey"
      :alwaysUpdate="true"
      :noRefreshAfterUpload="true"
      ref="dTable"
      :itemsPerPage="50"
      :addButtonCaption="addButtonCaption"
      :tableName="tableName"
      :hideTitle="true"
      table_title=""
      tableHeight="52vh"
    />
  </div>
</template>

<script>
import axios from "axios";
import * as fun from "../plugins/common";
export default {
  name: "SettingsMenu",
  components: {
    DTable: () => import("../components/Table.vue"),
  },
  props: {},
  data() {
    return {
      data_object: {
        object_name: "settings_menu",
        all_records: true,
      },
      tableReady: true,
      tableName: "Settings Menu",
      addButtonCaption: "Add Menu Item",
    };
  },
  mounted() {},

  beforeDestroy() {},
  methods: {},
};
</script>

<style lang="css" scoped></style>
